var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditHead = function SvgEditHead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 9 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AAA",
    fillRule: "evenodd",
    d: "M5.943.75c.1 0 .195.04.265.11l1.37 1.37a.375.375 0 0 1 0 .53L3.7 6.64a.38.38 0 0 1-.266.11H2.062a.375.375 0 0 1-.374-.375V5.01c0-.1.039-.195.11-.265L5.677.86c.07-.07.165-.11.265-.11m0 .906-3.505 3.51V6h.841l3.503-3.505zM.938 7.875c0-.207.167-.375.375-.375h6.75a.375.375 0 1 1 0 .75h-6.75a.375.375 0 0 1-.375-.375",
    clipRule: "evenodd"
  })));
};
export default SvgEditHead;